/* eslint-disable no-unused-expressions */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/anchor-is-valid */
import CN from 'classnames';
import { FC, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

export interface LeftNavProps {
  [x: string]: any;
  menuItemList?: any;
  firstRoute?: string | undefined;
  setIsMenuDrawerOpen?: any;
}

export const LeftNav: FC<LeftNavProps> = ({
  menuItemList = [],
  firstRoute,
  userDetails,
  setIsMenuDrawerOpen = undefined,
}: LeftNavProps) => {
  const navigate = useNavigate();
  const [menuItems, setMenuItems] = useState<any>([]);

  useEffect(() => {
    const filterSubMenus = menuItemList.map((item: any) => {
      return {
        ...item,
        subMenuItems: item.subMenuItems?.filter((item: any) => {
          return item.isActive;
        }),
      };
    });

    const filterMainMenu = filterSubMenus.filter((item: any) => {
      return item.isActive;
    });

    setMenuItems(filterMainMenu);
  }, [userDetails]);

  useEffect(() => {
    if (menuItems.length > 0 && (firstRoute || firstRoute === '')) {
      const itemsToUpdate = menuItems.map((item: any) => ({
        ...item,
        isSelected: item.url === `/${firstRoute}`,
      }));

      setMenuItems(itemsToUpdate);
    }
  }, [firstRoute, userDetails, menuItems.length]);

  const clickMainItem = (selectedItem: any) => {
    const itemToUpdate = menuItems;
    if (!selectedItem?.isSelected) {
      if (!selectedItem.hasSubmenu) {
        navigate(selectedItem.url);
        setIsMenuDrawerOpen(false);
      }
      const updatedItems = itemToUpdate.map((item: any) => {
        if (item.mainMenuId === selectedItem.mainMenuId) {
          return {
            ...item,
            isSelected: true,
            subMenuItems: item.subMenuItems.map((subItem: any) => {
              return {
                ...subItem,
                isSelected: false,
              };
            }),
          };
        }
        return {
          ...item,
          isSelected: false,
          subMenuItems: item.subMenuItems.map((subItem: any) => {
            return {
              ...subItem,
              isSelected: false,
            };
          }),
        };
      });
      setMenuItems(updatedItems);
    } else {
      navigate(selectedItem.url);
      setIsMenuDrawerOpen(false);
    }
  };

  return (
    <div className="side-bar-item-container h-full w-full mt-10">
      <ul className="flex flex-col h-full gap-y-3">
        {menuItems?.map((item: any, idx: any) => (
          <li key={item?.mainMenuItemKey} className="side-bar-item h-fit cursor-pointer">
            <div
              onClick={(e) => {
                e.stopPropagation();
                clickMainItem(item);
              }}
              className={CN(
                'side-bar-item__container flex items-center rounded-lg justify-start h-full w-full py-3 transition-all duration-500 pr-2 pl-8',
                {
                  'bg-[#C40D42] !text-white ': item?.isSelected,
                  'hover:bg-[#fbe6ec] text-[#C40D42]': !item?.isSelected,
                },
              )}
            >
              <div className="flex items-center justify-between gap-x-3 w-full">
                <span className="text-[24px] leading-none font-normal">{item?.icon}</span>
                <p className="font-medium text-base w-full text-left">{item?.name}</p>
              </div>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default LeftNav;
